import "./App.css";
import { useState } from "react";
import Regular from "./regular";
function App() {
  const [section, setSection] = useState("+2");
  const handleSectionSwitch = (e, data) => {
    e.preventDefault();
    switch (data) {
      case "+2":
        setSection("+2");
        break;
      case "alevel":
        setSection("alevel");
        break;
      case "ctevt":
        setSection("ctevt");
        break;
      case "foreign":
        setSection("foreign");
        break;
      default:
        return;
    }
  };
  return (
    <div className="h-[100vh] m-5 flex items-start md:items-center justify-center">
      <div className="flex flex-col items-center justify-start">
        <img src="/logo.png" alt="mmc-bsc-csit-association-logo" className="object-contain w-20 h-20 mb-5 o md:w-28 md:h-28" />
        <h1 className="px-2 font-sans text-xl font-bold text-center text-green-700 md:text-3xl">
          REQUIREMENTS TO ENROLL IN TU IOST B.Sc. CSIT
        </h1>

        <div className="flex border w-[97%] md:w-[90%] rounded-xl bg-green-50 py-5 items-center justify-center gap-3 mt-5 flex-col">
          <nav className="flex flex-col items-center justify-center w-full gap-2 md:flex-row">
            <div className="flex items-center justify-center gap-4">
              <button
                onClick={(e) => handleSectionSwitch(e, "+2")}
                className={` ${section === "+2" && " border-b-green-700"
                  } h-12 w-auto px-3 bg-green-100 text-green-700 border-b-2 border-green-100 transition-all rounded-t-lg font-semibold hover:bg-green-200`}
              >
                +2 Science
              </button>
              <button
                onClick={(e) => handleSectionSwitch(e, "alevel")}
                className={` ${section === "alevel" && " border-b-green-700"
                  } h-12 w-auto px-3 bg-green-100 text-green-700 border-b-2 border-green-100 transition-all rounded-t-lg font-semibold hover:bg-green-200`}
              >
                A Level
              </button>
            </div>
            <div className="flex items-center justify-center gap-4 px-3">
              <button
                onClick={(e) => handleSectionSwitch(e, "ctevt")}
                className={` ${section === "ctevt" && " border-b-green-700"
                  } h-12 w-auto px-3 bg-green-100 text-green-700 border-b-2 border-green-100 transition-all rounded-t-lg font-semibold hover:bg-green-200`}
              >
                CTEVT{`(3Y Diploma)`}
              </button>
              <button
                onClick={(e) => handleSectionSwitch(e, "foreign")}
                className={` ${section === "foreign" && " border-b-green-700"
                  } h-12 w-auto px-3 bg-green-100 text-green-700 border-b-2 border-green-100 transition-all rounded-t-lg font-semibold hover:bg-green-200`}
              >
                Foreign
              </button>
            </div>
          </nav>

          <div className="flex items-start justify-center w-full h-auto px-1 overflow-y-scroll rounded-xl md:p-3 no-scrollbar">
            <Regular section={section} />
          </div>
        </div>
        <div className="flex flex-col items-center justify-center w-full h-20 mt-10">
          <p className="font-sans text-lg font-semibold text-green-700">B.Sc. CSIT Help Desk </p>
          <p className="font-sans text-sm font-semibold text-green-700">Operated by MMC - B.Sc. CSIT Association</p>
          <p className="font-sans text-green-700"><a href="tel:9746225425" className="hover:underline">9746225425{' '}</a>
            | <a href="tel:9806035079" className="hover:underline">9806035079</a>
          </p>
          <p className="font-sans text-green-700">
            <a href="tel:9701667087" className="hover:underline">9701667087{' '}</a>
            | <a href="tel:9746879490" className="hover:underline">9746879490</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
